import { withErrorBoundary } from '@nile/components';
import { SVGIcon } from '@superops/super-icons';
import { Badge, Button, DisplayText, Link } from '@superops/ui-design-system';
import React from 'react';

const Header = ({
  subject,
  toggleActiveChat,
  removeChat,
  id,
  heading,
  icon,
  iconBg,
  onSubjectClick = () => {},
  onClose,
  isChatActive
}) => {
  const handleClose = () => {
    if (onClose) {
      onClose();
    }
    removeChat(id);
  };

  const minimizeOrMaximizeChat = () => {
    toggleActiveChat(id);
  };

  return (
    <div className="divider" id="conversation-popup-header">
      <div className="flex actr tw-px-4 tw-py-2">
        <div
          className="flex actr w100 tw-gap-x-4"
          onClick={minimizeOrMaximizeChat}
        >
          <div className="flex">
            <Badge radial status={iconBg}>
              <SVGIcon name={icon} />
            </Badge>
          </div>
          <div className="w100 pointer">
            <DisplayText element="p" size="large" weight="SemiBold">
              {heading}
            </DisplayText>
            <Link onClick={onSubjectClick} ellipsis>
              <DisplayText element="p" size="medium">
                {subject}
              </DisplayText>
            </Link>
          </div>
        </div>
        <div className="flex actr tw-gap-x-2">
          <Button plainSecondary onClick={minimizeOrMaximizeChat}>
            <SVGIcon name={isChatActive ? 'MinimiseSmall' : 'MaximisePopup'} />
          </Button>
          <Button plainSecondary onClick={handleClose}>
            <SVGIcon name="Close" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default withErrorBoundary(Header);
